export class Search {
	
	constructor() {
		let url = new URL(window.location.href);
		this.mid = url.searchParams.get('selected_mod_id');
		this.id = 0;
	}

	submit(parent) {
		let _this = this;
		
		$.ajax({
			type: "POST",
			url: '/vsop/ajax/' + this.mid + '/',
			dataType: 'html',
			data: $(parent).serialize() + '&action=load',
			success: function(data)
			{
				$('#object-cards').replaceWith(data);
				_this.applyEvents();
			},
			error: function(e)
			{
				alert(e);
			}
		});
	}

	toggleAll(parent)
	{
		$('.allpbspb-card__choice-input').prop('checked', $(parent).prop('checked'));
	}

	setDates(parent, type)
	{
		let date1 = new Date();
		let date2 = new Date();
		if (type == 'week')
			date1.setDate(date2.getDate() - 7);
		if (type == 'month')
			date1.setDate(date2.getDate() - 30);

		let period = date1.toLocaleDateString() + ' — ' + date2.toLocaleDateString();

		$(parent).closest('.form-item__main').find('.form-date__input--range').val(period).trigger('change');
	}

	applyEvents()
	{
		let _this = this;

		$('#search_card_all').on("click", function(){
			_this.toggleAll(this);
		})

		$(".allpbspb-objects__open-actions-popup").on("click", function () {
			let dataTypeName = $(this).attr("data-type-for");

			$(".allpbspb-objects__actions-popup[data-type!=" + dataTypeName + "]").removeClass("active");
			$(".allpbspb-objects__actions-popup[data-type=" + dataTypeName + "]").toggleClass("active");
		});

		$('.form-date__links a:first-child').click(function(){search.setDates(this, 'week'); return false;});
		$('.form-date__links a:last-child').click(function(){search.setDates(this, 'month'); return false;});
	}

	showObject(id)
	{
		$.ajax({
			type: "POST",
			url: '/vsop/ajax/' + this.mid + '/',
			dataType: 'html',
			data: {action: 'showObject', id: id},
			success: function(data)
			{
				$('.popup-allpbspb-object .popup__container').replaceWith($(data).find('.popup__container'));
				$(".popup-allpbspb-object").addClass("active");
				$("body").addClass("no-scroll");
				dragScroll.reset();

				$(".popup-allpbspb-object .popup__close, .popup-allpbspb-object .popup__cancel").on("click", function(e){
					$("body").removeClass("no-scroll");
					$(this).closest(".popup").removeClass("active");
				});

				var publicationsPopular = new Swiper('.popup-allpbspb-object__slider', {
				    slidesPerView: 1,
				    spaceBetween: 16,
				    observer: true,
				    observeParents: true,
				    navigation: {
				    	nextEl: '.popup-allpbspb-object__slider-nav-btn--next',
				    	prevEl: '.popup-allpbspb-object__slider-nav-btn--prev'
				    }
				});
			},
			error: function(e)
			{
				alert(e);
			}
		});
	}

	removeCard(parent)
	{
		let card = $(parent).closest('.card');
		card.remove();
		event.preventDefault();
		$('#cards_result .section__title-quantity').text($('#cards_result .section__title-quantity').text() - 1);
	}

	checkCards(parent)
	{
		if(!$(parent).find('.allpbspb-card__choice-input:checked').length)
		{
			alert('Выберите хотя бы одну карточку');
			return false;
		}
		
		return true;
	}

	resetFrom()
	{
		$('.form-multi__result-list').html('');
	}

	sendObj(id, type, parent)
	{
		$.ajax({
			type: "POST",
			url: '/vsop/ajax/' + this.mid + '/',
			dataType: 'json',
			data: {action: 'sendObj', id: id, type: type},
			success: function(res)
			{
				if (res.success)
				{
					$(parent).closest('.popup-allpbspb-object__mailing-item').find('span').text(res.newTime);
				}
				else
				{
					alert(res.error);
				}
			}
		});
	}

	/*downloadPdf()
	{
		download_pdf
		$('#cards_result').serialize();

		$.ajax({
			type: "POST",
			url: '/vsop/ajax/' + this.mid + '/',
			dataType: 'html',
			data: $('#cards_result').serialize() + '&action=download_pdf',
			success: function(data)
			{
				$('#object-cards').replaceWith(data);
				_this.applyEvents();
			},
			error: function(e)
			{
				alert(e);
			}
		});
	}*/
}